import gql from 'graphql-tag';

export const getSysLogs = gql`
  query ($start: AWSDateTime, $end: AWSDateTime) {
    getSysLogs(start: $start, end: $end, important: true) {
      sysLogId
      function
      date
      important
    }
  }
`
